import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ItemLinhaMultiselectComponent } from './item-linha-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        ItemLinhaMultiselectComponent
    ],
    exports: [
        ItemLinhaMultiselectComponent
    ]
})
export class ItemLinhaMultiselectModule { }
